import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import api from "../lib/api";

const SCALE = [
  { v: 1, l: "Not at all" }, { v: 2, l: "Rarely" }, { v: 3, l: "Sometimes" },
  { v: 4, l: "Mostly" }, { v: 5, l: "Completely" },
];

export default function Diagnostic() {
  const nav = useNavigate();
  const [qs, setQs] = useState([]);
  const [step, setStep] = useState(0);
  const [answers, setAnswers] = useState({});
  const [busy, setBusy] = useState(false);
  const [lock, setLock] = useState(false);

  useEffect(() => { api.get("/diagnostic/questions").then((r) => setQs(r.data.questions)); }, []);
  if (!qs.length) return <div className="min-h-screen bg-ink" />;

  const q = qs[step];
  const pct = Math.round(((step) / qs.length) * 100);
  const pick = async (v) => {
    if (busy || lock) return;
    const next = { ...answers, [q.id]: v };
    setAnswers(next);
    if (step < qs.length - 1) { setLock(true); setTimeout(() => { setStep(step + 1); setLock(false); }, 220); return; }
    setBusy(true);
    const { data } = await api.post("/diagnostic/submit", { answers: next });
    sessionStorage.setItem("wellthspan", JSON.stringify(data));
    nav("/diagnostic/results");
  };

  return (
    <div className="min-h-screen bg-ink text-ivory flex flex-col">
      <div className="fixed top-0 inset-x-0 h-[3px] bg-white/10 z-50">
        <div className="h-full bg-gold transition-all duration-500" style={{ width: `${busy ? 100 : pct}%` }} />
      </div>
      <div className="px-6 lg:px-10 pt-10 flex justify-between items-center max-w-4xl mx-auto w-full">
        <p className="font-display tracking-[0.3em] text-sm">WELLTHSPAN™</p>
        <p className="eyebrow">{step + 1} / {qs.length}</p>
      </div>
      <div className="flex-1 flex items-center justify-center px-6">
        {busy ? (
          <p className="font-headline italic text-3xl text-gold animate-pulse">Reading your capacity…</p>
        ) : (
          <AnimatePresence mode="wait">
            <motion.div key={q.id} initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -24 }}
              transition={{ duration: 0.4 }} className="max-w-2xl w-full">
              <p className="eyebrow mb-6">Balanced Life Index</p>
              <h2 className="font-headline text-3xl sm:text-4xl leading-tight mb-12">{q.text}</h2>
              <div className="space-y-px" data-testid="diagnostic-options">
                {SCALE.map((s) => (
                  <button key={s.v} data-testid={`option-${s.v}`} onClick={() => pick(s.v)}
                    className="w-full text-left px-6 py-4 border border-gold/20 hover:border-gold hover:bg-gold/10 transition-all flex justify-between items-center group">
                    <span className="text-sm">{s.l}</span>
                    <span className="font-display text-gold/40 group-hover:text-gold">{s.v}</span>
                  </button>
                ))}
              </div>
            </motion.div>
          </AnimatePresence>
        )}
      </div>
    </div>
  );
}
